"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvisorContext = void 0;
var react_1 = require("react");
var AdvisorContext_1 = require("../contexts/AdvisorContext");
//This custom hook is responsible for consuming the advisor context.
function useAdvisorContext() {
    var context = (0, react_1.useContext)(AdvisorContext_1.AdvisorContext);
    if (!context) {
        throw new Error('The useAdvisorContext must be used within an AdvisorProvider.');
    }
    return context;
}
exports.useAdvisorContext = useAdvisorContext;
//# sourceMappingURL=useAdvisorContext.js.map